// hooks
import { useContext } from "react";
// provider
import { HelmetContext } from "src/providers/HelmetProvider";

export const useHelmet = () => {
  return useContext(HelmetContext);
};
